import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-price-shares',
    templateUrl: './price-shares.component.html',
    styleUrls: ['./price-shares.component.scss']
})
export class PriceSharesComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
